<template>
    <div class="col-12 pb-3 d-flex justify-content-center legend">
        Não aplicável para essa promoção
    </div>
</template>
<script lang="ts">
    import { defineComponent } from 'vue'
    export default defineComponent({
        name: 'FormPaymentUnavailable'
    })
</script>
<style scoped lang="css">
    .legend {
        font-size: 15px;
        font-family: 'Roboto-Regular';
    }
</style>